export default "__VITE_ASSET__Cfu8QoJa__"